export default "__VITE_ASSET__BwBxOMg3__"